import cn from 'classnames';

import { useTextStyle } from '@webapp/common/components/custom-styles';
import { CssQuestionType } from '@webapp/common/components/survey-custom';
import { useMobile } from '@webapp/common/hooks/use-mobile';
import { createTextStyle } from '@webapp/common/lib/ui';
import type { InfoModel } from '@webapp/common/resources/entities/info';

import type { SurveyQuestion } from '@webapp/survey/src/components/questions/lib';

import { CsiRow } from './csi-row';

import css from './csi.css';

export const Csi: VFC<SurveyQuestion> = ({ question, actor }) => {
    const {
        answersActors,
        id: questionId,
        params: {
            amount,
            color,
            matrixNumbersColor,
            matrixType,
            size,
            minAmount,
            maxAmount,
            csiFormat,
            comment,
            commentText: commentTextHelp,
            cantRate,
            commentRequired,
            cantRateText,
        },
    } = question;

    const {
        info: {
            design: {
                fonts: {
                    questionTextBold,
                    questionTextColor,
                    questionTextItalic,
                    questionTextSize,
                    questionTextThrough,
                    questionTextUnderline,
                },
            },
        },
    } = (actor.getSnapshot().context.parentRef.getSnapshot() as any).context as { info: InfoModel };
    const isMobile = useMobile();
    const { listStyle, textStyle } = useTextStyle();
    const adjustedSize = isMobile ? 1 : size;
    const headerTitleStyles: CSSProperties = createTextStyle({
        underline: questionTextUnderline,
        through: questionTextThrough,
        bold: questionTextBold,
        italic: questionTextItalic,
        color: questionTextColor,
        size: questionTextSize,
    });

    return (
        <div className={cn(CssQuestionType.QUESTION, CssQuestionType.CSI, css.list)} style={listStyle}>
            {answersActors.map((answerActor) => (
                <CsiRow
                    questionId={questionId}
                    labelStyle={headerTitleStyles}
                    answer={answerActor}
                    color={color}
                    count={amount}
                    key={answerActor.getSnapshot().context.id}
                    matrixNumbersColor={matrixNumbersColor}
                    matrixType={matrixType}
                    size={adjustedSize}
                    style={textStyle}
                    minAmount={minAmount}
                    maxAmount={maxAmount}
                    csiFormat={csiFormat}
                    comment={comment}
                    commentTextHelp={commentTextHelp}
                    showCantRate={cantRate}
                    commentRequired={commentRequired}
                    cantRateText={cantRateText}
                />
            ))}
        </div>
    );
};
